module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Service-Page-w720.cb428dae.webp";